var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";


    function init() {
        Search();
        KeyboardNavigation();
    }

    function Search() {
        const searchOffcanvas = $("#site-header-search-offcanvas");
        const searchTextField = searchOffcanvas.find("input[type='text'].form-control");

        searchOffcanvas.on("shown.bs.offcanvas", function () {
            searchTextField.focus();
        });
    }

    function KeyboardNavigation() {
        var $topNavItem = $('.site-header-primary nav > ul > li');
        $topNavItem.on('keydown', function (e){
            if (e.keyCode == 37) { // left
                $(this).prev().focus();
            }
            else if (e.keyCode == 39) { // right
                $(this).next().focus();
            }
            else if (e.keyCode == 27) { // esc
                $(this).blur().find(':focus').blur();
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});